import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class InterceptorService implements HttpInterceptor {
    // Lista de URLs que no requieren el encabezado de autorización
    private excludedUrls: string[] = [
        environment.services.IpService,
        'Token/generar-token',
        'Token/renovar-token'
    ];

    constructor(
        private oAuthenticationService: AuthenticationService
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const isExcludedUrl = this.excludedUrls.some((url) =>
            request.url.includes(url)
        );

        // Si la URL está excluida, pasar directo sin token
        if (isExcludedUrl) {
            return next.handle(request).pipe(
                catchError((error) => throwError(() => error))
            );
        }

        // Para URLs protegidas, asegurar token válido (renovar si es necesario) ANTES de enviar request
        return this.oAuthenticationService.ensureValidToken('denuncias-app').pipe(
            switchMap((token: string) => {
                if (token) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    return next.handle(request);
                }
                this.oAuthenticationService.goToLogin();
                return throwError(() => new Error('No se pudo obtener un token válido'));
            }),
            catchError((error) => {
                // Si renewToken falló (401), intentar login
                if (error.status === 401) {
                    this.oAuthenticationService.goToLogin();
                    return throwError(() => new Error('Token expirado. Vuelva a iniciar sesión.'));
                }
                return throwError(() => error);
            })
        );
    }
}
